import script from "./vp-select.vue?vue&type=script&setup=true&lang=js"
export * from "./vp-select.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__